import React, { useEffect, useState } from "react";
import SlideRenderer from "./SlideRenderer";
import TaskSlide from "./TaskSlide";

export default function TutorialPlayer({
  tutorial,
  onLoadCode // (code: [string, string, string]) => void for [html, css, js]
}) {
  const [index, setIndex] = useState(0);
  const [solved, setSolved] = useState({});
  const [message, setMessage] = useState(null);

  const slide = tutorial.slides[index];

  useEffect(() => {
    // when we land on a task slide, preload starter code
    if (slide?.type === "task" && slide.task?.starter) {
      // Check if starter is an object with html/css/js properties or a string (legacy)
      if (typeof slide.task.starter === "object") {
        const html = slide.task.starter.html || "";
        const css = slide.task.starter.css || "";
        const js = slide.task.starter.js || "";
        onLoadCode([html, css, js]);
      } else {
        // Legacy support: treat as string with lang property
        const lang = slide.task.lang || "html";
        let html = "", css = "", js = "";
        
        if (lang === "html") {
          html = slide.task.starter;
        } else if (lang === "css") {
          css = slide.task.starter;
        } else if (lang === "js") {
          js = slide.task.starter;
        }
        
        onLoadCode([html, css, js]);
      }
      setSolved((s) => ({ ...s, [index]: false }));
    }
  }, [index]);

  const clickNext = () => {
    setIndex(i=>i+1);
    setMessage(null);
  };

  const canNext = () => {
    if (!slide) return false;
    if (slide.type === "task") return !!solved[index];
    return true;
  };

  return (
    <div className="p-4">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-lg font-semibold">{tutorial.title} <br /> {slide?.title}</h3>
        <div className="text-sm text-gray-600">Slide {index+1}/{tutorial.slides.length}</div>
      </div>

      <div className="bg-white rounded shadow p-4 mb-3 min-h-[220px]">
        {/* Render slide body or specialized interactive slide */}
        {slide?.type === "task" ? (
          <TaskSlide
            slide={slide}
            onCorrect={() => setSolved((s) => ({ ...s, [index]: true }))}
            onIncorrect={() => setSolved((s) => ({ ...s, [index]: false }))}
            message={message}
            setMessage={setMessage}
          />
        ) : (
          <SlideRenderer slide={slide} css={tutorial.slideCss} />
        )}
      </div>

      <div className="flex gap-2">
        <button className="px-3 py-1 bg-gray-100 rounded" disabled={index===0} onClick={() => setIndex(i=>i-1)}>Previous</button>
        <button className="px-3 py-1 bg-indigo-600 text-white rounded disabled:opacity-50 ml-auto" disabled={!canNext() || index===tutorial.slides.length-1} onClick={clickNext}>Next</button>
      </div>
    </div>
  );
}